import React, { useState, useEffect } from "react";
import "./AddProduct.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from 'aws-amplify/auth';

const AddProduct = () => {

  const [userId, setUserId] = useState(null);  
  const [product_type, setProductType] = useState("");
  const [product_serial_number, setSerialNumber] = useState("");
  const product_status = 1;
  const [product_group, setGroupName] = useState("");
  const [product_description, setDescription] = useState("");
  const [product_latitude, setLatitude] = useState("");
  const [product_longitude, setLongitude] = useState("");

  const [responseMessage, setResponseMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [addProductSuccess,setAddProductSuccess] = useState(false);
  const [modalSubMessage, setModalSubMessage] = useState("");
  
  // Product type array
  const productTypes = ["EVO-2212", "EVO-2224", "EVO-3012", "EVO-4024", "EVO-2212E", "EVO-2224E", "EVO-3012E", "EVO-4024E", "EVO-4248SP" ];

  const navigate = useNavigate();

    useEffect(() => {
      const fetchUserSession = async () => {
        try {
          const {userId} = await getCurrentUser();
          setUserId(userId);
  
        }
        catch {
          console.error("User is not logged in");
          navigate("/login");
        }
      };
      fetchUserSession();
    }, []); // Empty dependency array to run once when the component mounts

  const handleCancel = () => {
    navigate("/product"); // Replace '/addproduct' with your actual route path
  };

  const handleSave = async () => {
    try {
      const response = await fetch(
        "https://sucmhxbjlk.execute-api.us-east-1.amazonaws.com/prod/product/add",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": userId
          },
          body: JSON.stringify({
            product_type,
            product_serial_number,
            product_group,
            product_description,
            product_latitude,
            product_longitude,
          }),
        }
      );

      const data = await response.json();

      console.log(JSON.stringify(data));

      if (response.status === 200 && data.status === "ok") {
        setModalMessage("Product added successfully!");
        setModalSubMessage("Returning to the My Products page.");
        setAddProductSuccess(true);
        setShowModal(true);
      } else {
        setModalMessage(data.message || "Failed to add product.");
        setModalSubMessage("Review  product settings.");
        setAddProductSuccess(true);
        setShowModal(true);
      }
    } catch (error) {
      setModalMessage("An error occurred.");
      setModalSubMessage("Review product settings.");
      setAddProductSuccess(false);
      setShowModal(true);
    }
  };

  const handleModalOk = () => {
    setShowModal(false);
    if (addProductSuccess) {
      navigate("/product");
    }
  };

  return (
    <div className="addProductContainer">
      <div className="addProductHeader">
        <h1>Add Product</h1>
      </div>
      <div className="addProductForm">
        <div className="formGroup">
          <label>Product Type</label>
          <select
            value={product_type}
            onChange={(e) => setProductType(e.target.value)}
          >
            <option value="">Select a type</option>
            {productTypes.map((type, index) => (
              <option key={index} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        <div className="formGroup">
          <label>Serial Number</label>
          <input
            type="text"
            placeholder="Format: AAAAA-YYWW-BBBB"
            value={product_serial_number}
            onChange={(e) => setSerialNumber(e.target.value)}
          />
        </div>

        <div className="formGroup">
          <label>Group Name</label>
          <input
            type="text"
            placeholder="Enter group name (Max 32 characters)"
            maxLength="32"
            value={product_group}
            onChange={(e) => setGroupName(e.target.value)}
          />
        </div>

        <div className="formGroup">
          <label>Description</label>
          <textarea
            placeholder="Describe the product (Max 100 characters)"
            maxLength="100"
            value={product_description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div className="locationGroup">
          <div className="formGroup">
            <label>Latitude</label>
            <input
              type="text"
              placeholder="Latitude"
              value={product_latitude}
              onChange={(e) => setLatitude(e.target.value)}
            />
          </div>
          <div className="formGroup">
            <label>Longitude</label>
            <input
              type="text"
              placeholder="Longitude"
              value={product_longitude}
              onChange={(e) => setLongitude(e.target.value)}
            />
          </div>
        </div>

        <div className="formGroup saveButtonGroup">
          <button className="cancelButton" onClick={handleCancel}>
            <FontAwesomeIcon icon={faArrowLeft} />
            <div>Cancel</div>
          </button>
          <button className="saveButton" onClick={handleSave}>
            <FontAwesomeIcon icon={faSave} />
            <div>Save Product</div>
          </button>
        </div>
        
        <div className="modalContainer">
        {showModal && (
        <div className="modalBackdrop">
          <div className="modalPopup">
            <p>{modalMessage}</p>
            <p>{modalSubMessage}</p>
            <button className="modalButton" onClick={handleModalOk}>OK</button>
          </div>
        </div>
      )}
        </div>
      </div>
    </div>
  );
};

export default AddProduct;
